import { render, staticRenderFns } from "./ProjectDetailForm.vue?vue&type=template&id=503fbf5e&scoped=true&lang=pug&"
import script from "./ProjectDetailForm.vue?vue&type=script&lang=ts&"
export * from "./ProjectDetailForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectDetailForm.vue?vue&type=style&index=0&id=503fbf5e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503fbf5e",
  null
  
)

export default component.exports